import PropTypes from "prop-types";

import styled from "styled-components/macro";

import { colors } from "UI/colors";

const Div = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  color: ${colors.fnRedNotice};
  background-color: ${colors.fnYellowNotice};
  border-radius: 8px;
  border: 2px solid ${colors.fnRedNotice};
  padding: 4px 8px;
  font-size: inherit;
`;

const Notice = ({ children, as = "div", ...props }) => {
  if (as === "button") {
    return (
      <Button {...props}>
        <i className="fas fa-exclamation-triangle" />
        &nbsp; {children}
      </Button>
    );
  }

  return (
    <Div {...props}>
      <i className="fas fa-exclamation-triangle" />
      &nbsp; {children}
    </Div>
  );
};

const Button = styled(Notice).attrs({
  as: "button",
})`
  width: max-content;
  border-width: 1px;
  font-size: 12px;
  font-weight: 400;
  padding-block: 2px;
  color: ${colors.fnRedNotice};
  background-color: ${colors.fnYellowNotice};
  border-color: ${colors.fnRedNotice};
  border-style: solid;
  border-width: 2px;
  border-radius: 6px;
`;

Notice.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  style: PropTypes.string,
  as: PropTypes.oneOf(["div", "button"]),
};

export default Notice;
